module.exports = __webpack_public_path__ + "static/media/04.48bddc88.mp3";